// src/api/axiosInstance.js
import axios from 'axios'
import { API_CONFIG } from './config'

const axiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add API token if available
    if (API_CONFIG.TOKEN) {
      config.headers.Authorization = `Bearer ${API_CONFIG.TOKEN}`
    }

    // Add user-specific token from localStorage if available
    const userToken = localStorage.getItem('auth_token')
    if (userToken) {
      config.headers['X-User-Token'] = userToken
    }

    return config
  },
  (error) => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response

      switch (status) {
        case 401:
          console.error('Unauthorized: Invalid or expired token')
          // Optionally clear tokens and redirect to login
          // localStorage.removeItem('auth_token')
          // window.location.href = '/login'
          break
        case 403:
          console.error('Forbidden: Insufficient permissions')
          break
        case 404:
          console.error('Not Found:', data.message || 'Resource not found')
          break
        case 422:
          console.error('Validation Error:', data)
          break
        case 500:
          console.error('Server Error:', data.message || 'Internal server error')
          break
        default:
          console.error(`API Error (${status}):`, data)
      }
    } else if (error.request) {
      console.error('No response received from server')
    } else {
      console.error('Error setting up request:', error.message)
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
